export default __webpack_public_path__ + "media/images/hover-69d51c29e049302815c5333a562d4683.png";